module.exports = __webpack_public_path__ + "yz/img/东骏.11c772c6.jpg";